import React from 'react'
import SVG from '../../common/svg/SVG'
import { capitalize, getImageUrl } from './uspUtils'

const CollapsedUspModalMobile = ({onViewClick, onPrev, onNext, modalList, currentItemType }) => {
  const itemType = currentItemType || 'EXT';
  const { closeUpURL, key, desc } = modalList;
  const imageUrl = getImageUrl(modalList, itemType);
  
  const title = itemType === "EXT" 
    ? capitalize(modalList?.key) 
    : modalList?.reasons?.[0] ? capitalize(modalList?.reasons?.[0]) : capitalize(modalList?.key);
    
  const description = itemType === "EXT" 
    ? modalList?.desc 
    : modalList?.feature ? modalList?.feature : modalList?.desc;
  
  return (
    <div className='w-full h-[4rem] flex gap-3 items-center bg-[#222830] px-1'>
      <div className='w-[6.5rem] h-[3.25rem] rounded-lg overflow-hidden'>
        <img src={imageUrl} alt='Collapsed Usp Modal' className='w-full h-full object-cover' />
      </div>
      <div className='flex justify-between gap-1 w-full'>
        <div className='flex flex-col items-start gap-1'>
          <div className='flex justify-between gap-4 items-center'>
            <p className='text-[#FFFFFF] text-sm font-semibold'>{title}</p> 
            <button onClick={(e) => {
              e.isTrusted && onViewClick();
            }} className='text-[#FFCD00] text-xs font-semibold'>
              View →
            </button>
          </div>
          <p className='text-[#FFFFFF99] text-xs font-normal'>
            {description}
          </p>
        </div>
        <div className='flex flex-col items-center justify-center pr-2'>
          <button onClick={onPrev} className='text-[#FFCD00] text-xs font-semibold'>
            <img src="https://spyne-static.s3.us-east-1.amazonaws.com/upKey_arrow.svg" alt="minus" className='w-3 h-4' />
          </button>
          <button onClick={onNext} className='text-[#FFCD00] text-xs font-semibold'>
            <img src="https://spyne-static.s3.us-east-1.amazonaws.com/downKey_arrow.svg" alt="plus" className='w-7 h-6' />
          </button>
        </div>
      </div>
    </div>
  )
}

export default CollapsedUspModalMobile